export class FilesDirectory{

    constructor(
    	public id: any = '',
	    public directoryName: any = ''
    ){}
}